import { render, staticRenderFns } from "./BusinessDetail.vue?vue&type=template&id=7a42d224&scoped=true"
import script from "./BusinessDetail.vue?vue&type=script&lang=js"
export * from "./BusinessDetail.vue?vue&type=script&lang=js"
import style0 from "./BusinessDetail.vue?vue&type=style&index=0&id=7a42d224&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a42d224",
  null
  
)

export default component.exports